import { j as e } from "./atoms-v218.js";
import { Wrapper as $, RateCard as k, RateCardHeader as y, RateCardPriceSection as t, RateCardPrice as h, RateCardPriceText as a, RateCardTitle as x, RateCardDescription as C, CheckoutFooterWithBorderRadius as g } from "./atoms-v21036.js";
import { useBreakpoints as u } from "./atoms-v251.js";
const F = ({
  colorTheme: i,
  currentRate: c,
  footer: n,
  language: s,
  rates: d,
  setCurrentRate: j,
  setIsPriceBreakdownOpen: m,
  translations: l
}) => {
  const { current: p } = u();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx($, { children: d.slice(0, 2).map((r, o) => /* @__PURE__ */ e.jsxs(
      k,
      {
        $colorTheme: i,
        $isFirst: o === 0,
        $isLast: o === d.length - 1,
        $isSelected: (c == null ? void 0 : c.id) === r.id,
        onClick: () => j(r),
        children: [
          /* @__PURE__ */ e.jsx(y, { children: p === "small" ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsxs(t, { children: [
              /* @__PURE__ */ e.jsx(h, { $colorTheme: i, children: r.nightly_after_tax.toLocaleString(s, {
                currency: r.currency_code,
                style: "currency"
              }) }),
              /* @__PURE__ */ e.jsxs(a, { $colorTheme: i, children: [
                "/ ",
                l.night
              ] })
            ] }),
            /* @__PURE__ */ e.jsx(x, { $colorTheme: i, children: r.name })
          ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(x, { $colorTheme: i, children: r.name }),
            /* @__PURE__ */ e.jsxs(t, { children: [
              /* @__PURE__ */ e.jsx(h, { $colorTheme: i, children: r.nightly_after_tax.toLocaleString(s, {
                currency: r.currency_code,
                style: "currency"
              }) }),
              /* @__PURE__ */ e.jsxs(a, { $colorTheme: i, children: [
                "/ ",
                l.night
              ] })
            ] })
          ] }) }),
          /* @__PURE__ */ e.jsx(C, { $colorTheme: i, children: r.description })
        ]
      },
      r.id
    )) }),
    /* @__PURE__ */ e.jsx(
      g,
      {
        ...n,
        priceBreakdownLink: {
          ...n.priceBreakdownLink,
          onPriceBreakdownClick: () => m(!0)
        }
      }
    )
  ] });
};
export {
  F as AdditionalRatesAndPackages
};
